import { Inject, Injectable } from '@angular/core';

@Injectable()
export class IdleTimeoutWarningData {

    constructor(@Inject(Number) public countdown: number) { }

}
